import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { SaleItem } from '../../service/model/store.model';

export interface SaleCartState {
    saleItems: SaleItem[];
    isLoading: boolean;
}

export const initialState: SaleCartState = {
    saleItems: [],
    isLoading: false,
};

const saleCartSlice = createSlice({
    name: 'saleCart',
    initialState,
    reducers: {
        addItem(state, action: PayloadAction<SaleItem>) {
            state.saleItems.push(action.payload);
        },
        removeItem(state, action: PayloadAction<number>) {
            state.saleItems = state.saleItems.filter(
                (item) => item.id !== action.payload
            );
        },
        clearItems(state) {
            state.saleItems = [];
        },
        updateItem(state, action: PayloadAction<SaleItem>) {
            const index = state.saleItems.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.saleItems[index] = action.payload;
            }
        },
    },
    extraReducers: (builder) => {},
});

export const selectSaleItems = (state: RootState) => state.saleCart.saleItems;

export const { addItem, removeItem, updateItem, clearItems } =
    saleCartSlice.actions;

export default saleCartSlice.reducer;
